<!--
 * @Description: 
 * @Author: 
 * @Date: 2023-09-21 15:46:36
 * @LastEditTime: 2023-09-21 16:02:07
 * @LastEditors: Please set LastEditors
-->
<template>
  <div id="app">
   
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}

body{
  margin: 0;
  padding: 0;
}

/* ******************自定义样式****************** */
/* ---布局CSS--- */
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.flex-wrap {
  flex-wrap: wrap;
}

.justify-center {
  justify-content: center;
  -webkit-justify-content: center;
}

.justify-end {
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}

.justify-between {
  justify-content: space-between;
  -webkit-justify-content: space-between;
}

.justify-around {
  justify-content: space-around;
  -webkit-justify-content: space-around;
}

.justify-evenly {
  justify-content: space-evenly;
}



.align-start {
  align-items: flex-start;
  -webkit-align-items: flex-start;
}

.align-end {
  align-items: flex-end;
  -webkit-align-items: flex-end;
}

.align-baseline {
  align-items: baseline;
}

.flex-shrink {
  flex-shrink: 0;
}

.opacity-half {
  opacity: 0.5;
}

.color-white {
  color: #ffffff;
}

.mar-l-5 {
  margin-left: 5px;
}

.mar-r-5 {
  margin-right: 5px;
}

.mar-b-5 {
  margin-bottom: 5px;
}

.mar-t-5 {
  margin-top: 5px;
}

.mar-l-10 {
  margin-left: 10px;
}

.mar-r-10 {
  margin-right: 10px;
}

.mar-b-10 {
  margin-bottom: 10px;
}

.mar-t-10 {
  margin-top: 10px;
}

.mar-l-20 {
  margin-left: 20px;
}

.mar-r-20 {
  margin-right: 20px;
}

.mar-b-20 {
  margin-bottom: 20px;
}

.mar-t-20 {
  margin-top: 20px;
}

.mar-tb-5 {
  margin: 5px 0;
}

.mar-tb-10 {
  margin: 10px 0;
}

.br-t-no {
  border-top: unset;
}

.br-l-no {
  border-left: unset;
}

.br-r-no {
  border-right: unset;
}

.br-b-no {
  border-bottom: unset;
}
.fs30 {
  font-size: 30px;
}
.fs28 {
  font-size: 28px;
}

.fs26 {
  font-size: 26px;
}

.fs24 {
  font-size: 24px;
}

.fs22 {
  font-size: 22px;
}

.fs20 {
  font-size: 20px;
}

.fs18 {
  font-size: 18px;
}

.fs16 {
  font-size: 16px;
}

.fs14 {
  font-size: 14px;
}

.fs12 {
  font-size: 12px;
}

.fs10 {
  font-size: 10px;
}

.fs8 {
  font-size: 8px;
}

.fs6 {
  font-size: 6px;
}

.bold {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/App.vue